import {Component} from 'panel';

import * as Focusable from 'common/util/focusable';

export default class extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      focusable: {type: `boolean`, default: true},
    };
  }

  get config() {
    return {
      useShadowDom: true,
      helpers: {
        getComponentClasses: (prefixFilter) => {
          const componentClasses = {};
          for (const className of this.classList) {
            if (className.startsWith(prefixFilter)) {
              componentClasses[className] = true;
            }
          }
          return componentClasses;
        },

        getButtonAttrs: () => {
          const attrs = {};
          if (this.attr(`disabled`)) {
            attrs.disabled = true;
          }
          return attrs;
        },
      },
    };
  }

  get disabled() {
    return this.attr(`disabled`);
  }

  set disabled(disabled) {
    this.setAttribute(`disabled`, disabled);
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    Focusable.handleAttributeChangedCallback(this, attr);
    if (attr === `disabled`) {
      const disabled = this.attr(`disabled`);
      // this works better for browser compatibility by not even firing the click event if disabled
      this.style.pointerEvents = disabled ? `none` : ``;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute(`role`, `button`);

    Focusable.handleConnectedCallback(this);
  }

  disconnectedCallback() {
    Focusable.handleDisconnectedCallback(this);
    super.disconnectedCallback();
  }
}
